import { Routes } from '@angular/router';
import { authGuard, authMatchGuard } from './core/guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./error/page500/page500.component').then((m) => m.Page500Component),
  },
  {
    path: 'splash',
    canActivate: [authGuard],
    loadComponent: () => import('./auth/splash/splash.component').then((m) => m.SplashComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [authMatchGuard],
    loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./error/page404/page404.component').then((m) => m.Page404Component),
  },
];
